export default __webpack_public_path__ + "static/media/bubble2.bc4622bc.mp3";